module.exports = __webpack_public_path__ + "img/service5.cbaaa08c.png";